import React from 'react';
import { observer } from 'mobx-react';

import { Button as ChakraButton, ButtonGroup, Select } from '@chakra-ui/react';

const SortOrderButton = ({ sortOrder, SetSortOrder, asc, isFirst }) => {
  const isActive =
    (sortOrder === 'ASC' && asc) || (sortOrder === 'DESC' && !asc);
  return (
    <ChakraButton
      p='0.643em 0.643em'
      m='0'
      minWidth={0}
      size='sm'
      border='1px solid blue'
      borderRight={isFirst && 'none'}
      borderRadius='20px'
      backgroundColor={isActive && 'blue.50'}
      color='blue'
      cursor='pointer'
      _hover={{
        borderColor: 'blue',
        backgroundColor: 'blue.50',
      }}
      fontWeight='light'
      onClick={() => SetSortOrder((asc && 'ASC') || 'DESC')}
    >
      {(asc && '↑') || '↓'}
    </ChakraButton>
  );
};

export const SortByAction = observer(({ conn, columns }) => {
  // use Dropdown or SelectField?
  const { variables, SetSortField, SetSortOrder } = conn;
  const sortByOptions = columns
    .filter(col => col.isSortable)
    .map((col, i) => {
      return (
        <option key={i} value={col.accessor}>
          {col.Header}
        </option>
      );
    });
  if (sortByOptions.length === 0) {
    return null;
  }
  return (
    <>
      <Select
        borderColor='blue'
        borderRadius='20px'
        color='blue'
        cursor='pointer'
        _hover={{
          borderColor: 'blue',
          backgroundColor: 'blue.50',
        }}
        w={{
          base: '300px',
          md: 'unset',
        }}
        size='sm'
        onChange={e => {
          SetSortField(e.target.value);
        }}
        value={variables.sortField}
      >
        {sortByOptions}
      </Select>
      <ButtonGroup isAttached variant='ghost' colorScheme='blue'>
        <SortOrderButton
          SetSortOrder={SetSortOrder}
          sortOrder={variables.sortOrder}
          asc
          key='up'
          isFirst
        />
        <SortOrderButton
          SetSortOrder={SetSortOrder}
          sortOrder={variables.sortOrder}
          key='down'
        />
      </ButtonGroup>
    </>
  );
});
